<template>
  <div
    class="comunication-bar"
    :class="{ showingSideBar: showingSideBarComunication }"
    @mouseenter="handleSidebarInteraction"
    @mouseover="handleSidebarInteraction"
    @click="handleSidebarInteraction"
  >
    <ul class="alert__list">
      <li id="tabMensagens">
        <div class="tab-container">
          <tab
            :label="'MENSAGENS'"
            :showing-tab="showingTab"
            :messages-amount="getMessagesNumber"
            :class="{ highlighted: showingTab }"
            @click.native="changeTabShowOff(true)"
          />
          <tab
            :label="'NOTIFICAÇÕES'"
            :showing-tab="showingTab"
            :messages-amount="getAlertsNumber"
            :class="{ highlighted: !showingTab }"
            @click.native="changeTabShowOff(false)"
          />
        </div>

        <transition-group
          id="notification_container"
          name="slides-fade"
          tag="div"
          class="alerts-container"
          :class="{ showContainer: !showingTab }"
          enter-active-class="slid-fade-enter-active"
          leave-active-class="slides-fade-leave-active"
        >
          <div
            v-for="(message, index) in notificationsForLaboratories"
            v-if="notificationsForLaboratories.length > 0"
            :key="'alert-' + index"
            class="message-container"
          >
            <icon :team="message.type" />
            <message-box
              :message="message"
              @click.native="openNotification(message)"
            />
          </div>
        </transition-group>

        <div
          class="readed-notifications"
          :class="{ showContainer: !showingTab }"
        >
          <h5>Notificações Lidas</h5>
        </div>

        <transition-group
          id="notification_container"
          name="slides-fade"
          tag="div"
          class="alerts-container"
          :class="{ showContainer: !showingTab }"
          enter-active-class="slid-fade-enter-active"
          leave-active-class="slides-fade-leave-active"
        >
          <div
            v-for="(message, index) in readedNotifications"
            v-if="readedNotifications.length > 0"
            :key="'alert-readed' + index"
            class="message-container"
          >
            <icon :team="message.type" />
            <message-box
              :message="message"
              @click.native="openNotification(message)"
            />
          </div>
        </transition-group>

        <!-- Message -->
        <transition-group
          id="message_container"
          name="slides-fade"
          tag="div"
          class="alerts-container"
          :class="{ showContainer: showingTab }"
          enter-active-class="slid-fade-enter-active"
          leave-active-class="slides-fade-leave-active"
        >
          <div
            v-for="(message, index) in messageForLaboratories"
            v-if="messageForLaboratories.length > 0"
            :key="'message-' + index"
            class="message-container"
          >
            <icon />
            <message-box
              :message="message"
              @click.native="openNotification(message)"
            />
          </div>
        </transition-group>

        <empty-message
          :type="'mensagens'"
          :class="{ showContainer: showingTab }"
        />
      </li>
    </ul>

    <NotificationModal
      ref="notificationModal"
      :title="notificationTitle"
      :url="notificationLink"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import comunicationService from '@/api/comunication'
import Moment from 'moment'

import MessageBox from './MessageBox'
import EmptyMessage from './EmptyMessage'
import Tab from './Tab'
import Icon from './Icon'
import NotificationModal from '../NotificationModal.vue'

export default {
  name: 'ComunicationBar',
  components: {
    'message-box': MessageBox,
    'empty-message': EmptyMessage,
    tab: Tab,
    icon: Icon,
    NotificationModal,
  },
  data: () => {
    return {
      showingSideBarComunication: false,
      showingTab: false,
      notificationLink: '',
      notificationTitle: '',
    }
  },
  computed: {
    ...mapGetters([
      'isComunicationSidebarVisible',
      'getAlertsNumber',
      'notificationsForLaboratories',
      'profile',
      'whereIsTabSelected',
      'getMessagesNumber',
      'messageForLaboratories',
      'readedNotifications',
    ]),
  },
  watch: {
    isComunicationSidebarVisible() {
      if (this.isComunicationSidebarVisible) {
        this.showingSideBarComunication = true
      } else {
        this.showingSideBarComunication = false
        this.refresh()
      }
    },
    whereIsTabSelected() {
      if (this.whereIsTabSelected) {
        this.showingTab = true
      } else {
        this.showingTab = false
      }
    },
  },
  beforeDestroy() {
    this.showingSideBarComunication = false
    this.showingTab = false
  },
  mounted() {
    this.changeTabShowOff(false)
  },
  methods: {
    ...mapActions([
      'getAlertsForLaboratory',
      'getMessagesForLaboratory',
      'clearAlertDataForLaboratory',
      'clearAllMessageData',
      'changeTabShowOff',
      'deleteSelectedAlerts',
      'deleteSelectedMessages',
    ]),
    handleSidebarInteraction() {
      this.$root.$emit('sidebarInteraction')
    },
    markAlertAsRead(notification) {
      notification.read = true
      notification['id-laboratory'] = this.profile.id_laboratory
      notification['read-date'] = Moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      return comunicationService.markAlertAsRead(notification).then(() => {
        let index = this.notificationsForLaboratories.indexOf(notification)
        this.deleteSelectedAlerts(index)
        this.refresh()
      })
    },
    markMessageAsRead(message) {
      message.read = true
      message['read-date'] = Moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      message['id-operator'] = this.profile.id
      message['id-laboratory'] = this.profile.id_laboratory
      return comunicationService.markMessageAsRead(message).then(() => {
        let index = this.messageForLaboratories.indexOf(message)
        this.deleteSelectedMessages(index)
      })
    },
    refresh() {
      this.clearAlertDataForLaboratory()
      this.clearAllMessageData()
      this.getAlertsForLaboratory()
      this.getMessagesForLaboratory()
    },
    openNotification(notification) {
      console.log('Notification clicada: ', notification)
      if (notification.link) {
        this.notificationTitle = notification.title
        this.notificationLink = notification.link

        this.$nextTick(() => {
          this.$refs.notificationModal.openModal()
        })
      }
      if (!notification.read) {
        this.markAlertAsRead(notification)
      }
    },
  },
}
</script>

<style lang="scss">
@import '../../../../static/stylesheets/variables';

.comunication-bar {
  background: linear-gradient(to left, #f1f1f1 90%, rgba(0, 0, 0, 0) 10%);
  width: 0;
  flex-grow: 0;
  margin-top: $mainHeaderHeight;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 104;
  transition: width 0.3s;
  transition-delay: 0.15s;
  height: 100%;
  overflow: hidden;

  .readed-notifications {
    flex-wrap: wrap;
    width: 90%;
    float: right;
    z-index: 100;
    background-color: #f4f4f4;
    position: relative;

    h5 {
      padding: 15px 14px 15px 0;
      color: #fff;
      width: 100%;
      display: flex;
      justify-content: center;
      font-weight: 700;
      background: #d0d0d0;
      text-transform: uppercase;
    }
  }

  .tab-container {
    display: flex;
    width: 90%;
    float: right;
    background: #f4f4f4;

    .highlighted {
      border-bottom-color: #840051;
      color: #840051;
    }
  }

  .alert {
    &__list {
      overflow: scroll;
      height: 100%;
      -ms-overflow-style: -ms-autohiding-scrollbar;
      -ms-overflow-style: none;
      padding-right: 20px;
      width: 103%;
      box-sizing: content-box;
    }

    &__list::-webkit-scrollbar {
      width: 0px;
      background: transparent; /* make scrollbar transparent */
    }
    &__item {
      display: flex;
      flex-direction: column;
      cursor: pointer;
      position: relative;
      outline: 0;
      margin: 0;

      &:not(.md-button) {
        color: #4c4f59;
      }

      &:hover {
        z-index: 10;

        &:not(.md-button) {
          color: #4c4f59;
          text-decoration: none;
        }

        .alert__item__icon {
          border-left: 3px solid #7f1a54;
        }

        .second-level {
          height: 65px;
          transition: height 0.2s;
        }
      }

      &.active {
        z-index: 10;

        .alert__item__text {
          color: #4c4f59;
        }

        .alert__item__icon {
          border-left: 3px solid #7f1a54;
        }
      }

      .second-level {
        width: 100%;
        height: 0px;
        overflow: hidden;
        transition: height 0.2s;
      }

      &__icon {
        padding: 12px 0;
        border-left: 3px solid #fff;
        height: 50px;
        width: 50px;
        display: flex;
        justify-content: center;
        margin: 0;

        svg {
          width: 22px;
        }

        &.narrow svg {
          width: 18px;
        }
      }
    }
    &__subalert {
      margin: 2px 0 24px 52px;

      &__item {
        font-size: 12px;
        color: #949497;
        text-align: left;
        margin: 0 0 13px 4px;
        font-weight: 500;
        display: flex;
        flex-wrap: nowrap;
        white-space: nowrap;

        &::before {
          content: '■';
          color: #7f1a54;
          display: inline-block;
          width: 17px;
          margin-right: 10px;
          font-size: 8px;
        }

        &:hover {
          color: #4c4f59;
        }

        &:last-child {
          margin-bottom: 0;
        }

        a,
        a:hover,
        a:visited {
          color: inherit;
          text-decoration: none;
        }
      }
    }
  }

  &.showingSideBar {
    width: 450px;
    transition: width 0.3s;
    padding-bottom: 40px;
  }

  .remove-margin {
    margin-bottom: 0 !important;
  }
}

.showContainer {
  display: flex !important;
}

.message-container {
  width: 100%;
  display: flex;
}

.alerts-container {
  display: none;
  flex-wrap: wrap;
  width: 100%;
}

.slid-fade-enter-active {
  transition: opacity 0.4s;
  transition-delay: 0.4s;
}

.slides-fade-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
  -webkit-transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
  transform: translateX(400px);
  transition-delay: 0.2s;
}
.slides-fade-enter
  /* .slides-fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
  transition-delay: 0.15s;
}

.slides-fade-leave-to {
  opacity: 0;
  transition-delay: 0.15s;
}
</style>
